import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
import { type FieldValues, type Path, type RegisterOptions, useFormContext, useFormState } from 'react-hook-form';
import type { LabelTooltipProps } from '../../label';
import Radio, { type RadioProps } from '../../radio';
import FormWrapper from '../internals/form-wrapper';
export type FormRadioProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  label?: string | React.ReactNode;
  rules?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
  errorPosition?: 'absolute' | 'relative';
  orientation?: 'vertical' | 'horizontal';
  addon?: React.ReactNode;
  tooltip?: LabelTooltipProps;
} & Omit<RadioProps, 'checked' | 'defaultChecked' | 'name' | 'onBlur' | 'ref' | 'label' | 'hasError'>;
export default function FormRadio(t0) {
  const $ = _c(46);
  let addon;
  let baseId;
  let label;
  let name;
  let onChange;
  let radioProps;
  let rules;
  let t1;
  let t2;
  let tooltip;
  if ($[0] !== t0) {
    ({
      name,
      rules,
      label,
      id: baseId,
      errorPosition: t1,
      orientation: t2,
      addon,
      onChange,
      tooltip,
      ...radioProps
    } = t0);
    $[0] = t0;
    $[1] = addon;
    $[2] = baseId;
    $[3] = label;
    $[4] = name;
    $[5] = onChange;
    $[6] = radioProps;
    $[7] = rules;
    $[8] = t1;
    $[9] = t2;
    $[10] = tooltip;
  } else {
    addon = $[1];
    baseId = $[2];
    label = $[3];
    name = $[4];
    onChange = $[5];
    radioProps = $[6];
    rules = $[7];
    t1 = $[8];
    t2 = $[9];
    tooltip = $[10];
  }
  const errorPosition = t1 === undefined ? "relative" : t1;
  const orientation = t2 === undefined ? "vertical" : t2;
  const {
    register,
    control,
    getFieldState
  } = useFormContext();
  let t3;
  if ($[11] !== control || $[12] !== name || $[13] !== radioProps.disabled) {
    t3 = {
      control,
      name,
      disabled: radioProps.disabled
    };
    $[11] = control;
    $[12] = name;
    $[13] = radioProps.disabled;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const formState = useFormState(t3);
  let t4;
  if ($[15] !== formState || $[16] !== getFieldState || $[17] !== name) {
    t4 = getFieldState(name, formState);
    $[15] = formState;
    $[16] = getFieldState;
    $[17] = name;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  const {
    error
  } = t4;
  const contextId = useId();
  const id = baseId || contextId;
  let t5;
  if ($[19] !== name || $[20] !== register || $[21] !== rules) {
    t5 = register(name, {
      ...rules
    });
    $[19] = name;
    $[20] = register;
    $[21] = rules;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let reactHookFormOnChange;
  let rest;
  if ($[23] !== t5) {
    ({
      onChange: reactHookFormOnChange,
      ...rest
    } = t5);
    $[23] = t5;
    $[24] = reactHookFormOnChange;
    $[25] = rest;
  } else {
    reactHookFormOnChange = $[24];
    rest = $[25];
  }
  const t6 = error?.message;
  const t7 = formState.disabled || radioProps.disabled;
  let t8;
  if ($[26] !== onChange || $[27] !== reactHookFormOnChange) {
    t8 = e => {
      reactHookFormOnChange(e);
      onChange?.(e);
    };
    $[26] = onChange;
    $[27] = reactHookFormOnChange;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  const t9 = formState.disabled || radioProps.disabled;
  const t10 = !!error;
  let t11;
  if ($[29] !== id || $[30] !== label || $[31] !== radioProps || $[32] !== rest || $[33] !== t10 || $[34] !== t8 || $[35] !== t9) {
    t11 = <Radio {...radioProps} {...rest} onChange={t8} disabled={t9} hasError={t10} id={id} data-dd-privacy="mask" label={label} />;
    $[29] = id;
    $[30] = label;
    $[31] = radioProps;
    $[32] = rest;
    $[33] = t10;
    $[34] = t8;
    $[35] = t9;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== addon || $[38] !== errorPosition || $[39] !== id || $[40] !== orientation || $[41] !== t11 || $[42] !== t6 || $[43] !== t7 || $[44] !== tooltip) {
    t12 = <FormWrapper id={id} error={t6} errorPosition={errorPosition} addon={addon} size="default" orientation={orientation} fullWidth={true} disabled={t7} tooltip={tooltip}>{t11}</FormWrapper>;
    $[37] = addon;
    $[38] = errorPosition;
    $[39] = id;
    $[40] = orientation;
    $[41] = t11;
    $[42] = t6;
    $[43] = t7;
    $[44] = tooltip;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  return t12;
}